import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { UserController } from "services/user/UserController";
import { Card, Footer, Header, Link, Sidebar, TopNav } from "stories";
import { useFetchState } from "utils/customHooks/useFetchState";
import { useInfo } from "utils/customHooks/useInfo";
import classes from "./AppLayout.module.scss";

const AppLayout = ({
  title,
  hideSidebar,
  hideTopNav,
  backButton,
  backButtonUrl,
  rightSection,
  children,
}) => {
  const user = UserController();
  const [signOutState, handleUserSignOut] = useFetchState();
  const navigate = useNavigate();

  const menuWrapperRef = useRef();
  const menuInputRef = useRef();

  const { info, updateInfo } = useInfo();

  useEffect(() => {
    document.addEventListener("click", (e) => {
      const isClickInsideElement = menuWrapperRef.current?.contains(e.target);
      if (!isClickInsideElement && menuInputRef.current) {
        menuInputRef.current.checked = false;
      }
    });
    updateInfo();
    //TODO: remove event listener (unmount)
  }, []); // eslint-disable-line

  useEffect(() => {
    if (
      !signOutState.isLoading &&
      !signOutState.isError &&
      signOutState.data === ""
    ) {
      localStorage.removeItem("token");
      navigate("/sign-in");
    }
  }, [signOutState, navigate]);

  const menuContent = [
    {
      key: "dashboard",
      title: "Dashboard",
      path: "/dashboard",
    },
    {
      key: "opportunities",
      title: "My Opportunities",
      path: "/opportunities",
    },
  ];
  return (
    <div className={classes["app-layout"]}>
      <Header>
        <div className="d-flex align-items-center">
          <div className={`${classes["header-icon"]} icon-bell`} />
          <div ref={menuWrapperRef}>
            <input
              ref={menuInputRef}
              type={"checkbox"}
              id={"account-menu-input"}
            />
            <label
              htmlFor={"account-menu-input"}
              role={"button"}
              className={"fw-bold user-select-none"}
            >
              <span>Account</span>
              <span className={"icon-down-dir ms-2"} />
            </label>
            <div className={classes["account-menu"]}>
              <Card>
                <Link to={"/profile"} inherit>
                  <li role={"button"}>Profile</li>
                </Link>
                <li
                  role={"button"}
                  onClick={() => handleUserSignOut(user.deleteSession, null)}
                >
                  Sign Out
                </li>
              </Card>
            </div>
          </div>
        </div>
      </Header>
      <div
        className={`${classes["content-wrapper"]} ${
          !hideSidebar ? classes["sidebar-offset"] : ""
        }`}
      >
        {!hideSidebar ? (
          <>
            <Sidebar userInfo={info} menuContent={menuContent} />
          </>
        ) : null}
        <div className={"w-100 relative"}>
          {!hideTopNav ? (
            <TopNav
              title={title}
              backButton={backButton}
              backButtonUrl={backButtonUrl}
              offset={hideSidebar}
              rightSection={rightSection}
            />
          ) : undefined}
          <div className={`${classes["main-content"]} ${hideTopNav && "pt-0"}`}>
            {children}
          </div>
        </div>
      </div>
      <Footer minimized>
        <div className={`${classes["footer-link"]}`}>
          <Link to={""} inherit>
            FAQ
          </Link>
          <Link to={""} inherit>
            Contact Us
          </Link>
        </div>
      </Footer>
    </div>
  );
};

export default AppLayout;
